import { render, staticRenderFns } from "./overseas_index.vue?vue&type=template&id=76ac51b0&scoped=true"
import script from "./overseas_index.vue?vue&type=script&lang=js"
export * from "./overseas_index.vue?vue&type=script&lang=js"
import style0 from "./overseas_index.vue?vue&type=style&index=0&id=76ac51b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac51b0",
  null
  
)

export default component.exports